module.exports = function() {
  return new Worker(__webpack_public_path__ + "e3a8d4edf0182c7a8c5f.worker.js");
};